import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "col-span-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Regular sleeping arrangement "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*")
], -1)
const _hoisted_3 = { class: "flex lg:flex-row flex-col lg:space-x-6 lg:space-y-0 space-y-3" }
const _hoisted_4 = { class: "flex md:flex-row flex-col flex-shrink-0 md:mt-5 mt-3 md:space-x-3 md:space-y-0 space-y-3" }
const _hoisted_5 = { class: "col-span-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Same bed / mat with: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-400" }, "(check all that apply)")
], -1)
const _hoisted_7 = {
  class: "flex md:flex-row flex-col flex-shrink-0 md:mt-5 mt-3 md:space-x-6 md:space-y-0 space-y-3",
  id: "same_bed_with"
}
const _hoisted_8 = {
  key: 0,
  class: "text-[10px] mt-1 text-red-600",
  id: "email-error"
}
const _hoisted_9 = { class: "col-span-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Same room with: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-400" }, "(check all that apply)")
], -1)
const _hoisted_11 = {
  class: "flex md:flex-row flex-col flex-shrink-0 md:mt-5 mt-3 md:space-x-6 md:space-y-0 space-y-3",
  id: "same_room_with"
}
const _hoisted_12 = {
  key: 0,
  class: "text-[10px] mt-1 text-red-600",
  id: "email-error"
}
const _hoisted_13 = { class: "col-span-12 flex lg:flex-row flex-col align-baseline gap-5 lg:pr-5" }
const _hoisted_14 = { class: "lg:w-1/2 flex-shrink-0 border rounded p-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600 mb-2" }, [
  /*#__PURE__*/_createTextVNode("Living arrangement at time of abuse: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-400" }, "(check all that apply)")
], -1)
const _hoisted_16 = { class: "sm:columns-2 incest_checklist--livingArr gap-0" }
const _hoisted_17 = {
  key: 0,
  class: "text-[10px] mt-1 text-red-600",
  id: "email-error"
}
const _hoisted_18 = { class: "lg:w-1/2 flex-shrink-0 border rounded p-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600 mb-2" }, [
  /*#__PURE__*/_createTextVNode("Living arrangement at present: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-400 sm:inline-block block" }, "(check all that apply)")
], -1)
const _hoisted_20 = { class: "sm:columns-2 incest_checklist--livingArr gap-0" }
const _hoisted_21 = {
  key: 0,
  class: "text-[10px] mt-1 text-red-600",
  id: "email-error"
}

import PageLoader from "@/components/loaders/PageLoader.vue"
import IntakeLayout from '../../Component/IntakeLayout.vue';
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import { ref, onMounted, watch, computed } from 'vue';
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { useRoute } from "vue-router";
import { OptionInterface } from '@/interfaces/OptionInterface'; 
import { SleepingArrangement } from '@/enums/SleepingArrangement';
import { errorResponse } from "@/helpers/errorMessage"; 
import { onIonViewWillEnter } from "@ionic/vue"; 
 
 
 /******************************* For Offline Imports************************************ */
 import { useNetworkStore } from "@/store/network";
 import Rules from "@/classes/Cases/Intake/Incest/Validation/Rules";
 import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
 import useVuelidate from "@vuelidate/core"; 
 import IncestForm from "@/classes/Cases/Intake/Incest/Formatter/IncestForm"; 
 import IncestService from "@/classes/Cases/Intake/Incest/IncestService";
 import IncestOfflineProcessor from "@/classes/Cases/Intake/Incest/Processor/OfflineProcessor";
 import OnlineSynching from "@/classes/Synching/OnlineSynching";

 
export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const { createRules } = Rules;
 const networkStore = useNetworkStore();
 const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable); 
 /*************************************************************************************** */
 
const route = useRoute();
const showSuccess = ref<boolean>(false);
const loading = ref<boolean>(false);
const errors = ref<any>();
const patient = ref<string>(''); 

const route_params = route.params; 

const form = ref(IncestForm.createForm());

const sleepingArrangement = ref<OptionInterface[]>([])
const sleepingArrangementWith = ref<OptionInterface[]>([])
const livingArrangements = ref<OptionInterface[]>([])
const isIonWillEnter = ref<boolean>(false);
const onlineSync = new OnlineSynching();

let incestId;
const fetch = async (): Promise<any> => {
	loading.value = true
 
	await IncestService
	.show(route_params?.patient, route_params?.case, isNetworkAvailable.value)
	.then(async ({data}) => {
		console.log(data);
		sleepingArrangement.value = data.sleepingArrangement
		patient.value = data.patient
		sleepingArrangementWith.value = data.sleepingArrangementWith
		livingArrangements.value = data.livingArrangements
		
		Object.assign(form.value, data.item); 
		incestId = form.value.id;
        if (isNetworkAvailable.value) {
            await syncToOffline();
        }
		loading.value = false
	})
	.catch(errors => {
		console.log(errors);
	})
   
}

const syncToOffline = async () => {
    await IncestOfflineProcessor.syncToOffline(route_params?.case, form.value);
}
 
 /**
 * Validate the form using Vuelidator
 */
 const validateForm = () =>{
	const vuelidate = useVuelidate(createRules({...form.value}), form.value)
	const result = vuelidate.value.$validate();
	result
		.then((res) => {
			if(res) { 
				update()
			} else {
				errors.value = ErrorValidation.getErrors(vuelidate.value)
                errorResponse(errors.value);
			}
		})
 }
 

const update = async (): Promise<any> => {
	loading.value = true 
	await IncestService
		.update(incestId,route_params?.patient, route_params?.case, isNetworkAvailable.value, form.value, )
		.then(async ({data}) => {
			loading.value = false
			showSuccess.value = true;
            errors.value = {};
			await fetch(); 
            setTimeout(() => showSuccess.value = false, 2000);
		})
		.catch(error => {
			errors.value = errorResponse(error.response?.data?.errors)
			loading.value = false
		})
    
}


const removeAddRelatedTypes = (list:any, item:number): void => {
	const index = list.indexOf(item)
 
	if(index > -1){
		list.splice(index, 1);
	} else {
		list.push(item);
	} 
}

watch(
	()=> form.value.sleeping_arrangement,
	()=>{
		if(form.value.sleeping_arrangement !== SleepingArrangement.OTHERS
			&& form.value.sleeping_arrangement !== SleepingArrangement.SHELTER
		){
			form.value.others = null;
		}
	}
)
watch(
	() => [form.value.abused_living_arrangement, form.value.present_living_arrangement],
	([abused, present]) => {
		if(!abused){
			form.value.abused_living_arrangement = [];
		}
		if(!present) {
			form.value.present_living_arrangement = [];
		}
	}
)
watch(
	()=> form.value.sleeping_arrangement,
	()=>{
		if(form.value.sleeping_arrangement !== SleepingArrangement.OTHERS
			&& form.value.sleeping_arrangement !== SleepingArrangement.SHELTER
		){
			form.value.others = null;
		}
	}
)
watch(
	()=> form.value.sleeping_arrangement,
	()=>{
		if(form.value.sleeping_arrangement !== SleepingArrangement.OTHERS
			&& form.value.sleeping_arrangement !== SleepingArrangement.SHELTER
		){
			form.value.others = null;
		}
	}
)

onIonViewWillEnter(async () => {
    if (isIonWillEnter.value) {
        errors.value = null;
        await fetch();
        await onlineSync.checkDrafts();
    }
});

onMounted(async () => {
	await fetch();
    await onlineSync.checkDrafts();
    isIonWillEnter.value = true;
    errors.value = null;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IntakeLayout, { patient: patient.value }, {
    actionButtons: _withCtx(() => [
      _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
        default: _withCtx(() => [
          _createTextVNode("Cancel")
        ]),
        _: 1
      }),
      _createVNode(ButtonComponent, {
        customClass: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (validateForm()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Save Changes ")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(RadioGroup, {
              options: sleepingArrangement.value,
              name: "option_selected",
              required: "",
              id: "sleeping_arrangement",
              modelValue: form.value.sleeping_arrangement,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.sleeping_arrangement) = $event)),
              error: errors.value?.sleeping_arrangement
            }, null, 8, ["options", "modelValue", "error"])
          ]),
          (form.value.sleeping_arrangement === _unref(SleepingArrangement).SHELTER || form.value.sleeping_arrangement === _unref(SleepingArrangement).OTHERS)
            ? (_openBlock(), _createBlock(TextInput, {
                key: 0,
                label: form.value.sleeping_arrangement === _unref(SleepingArrangement).SHELTER ? 'Please specify shelter' : 'Others',
                placeholder: form.value.sleeping_arrangement === _unref(SleepingArrangement).SHELTER ? 'Please specify shelter' : 'Others',
                name: "specify",
                id: "others",
                modelValue: form.value.others,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.others) = $event)),
                error: errors.value?.others
              }, null, 8, ["label", "placeholder", "modelValue", "error"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sleepingArrangementWith.value, (option) => {
            return (_openBlock(), _createBlock(CheckboxInput, {
              key: option.label,
              id: 'bed' +option.id,
              name: option.value,
              label: option.label,
              checked: form.value.same_bed_with.indexOf(option.id) > -1,
              onClick: ($event: any) => (removeAddRelatedTypes(form.value.same_bed_with, option.id))
            }, null, 8, ["id", "name", "label", "checked", "onClick"]))
          }), 128))
        ]),
        (errors.value?.same_bed_with)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errors.value?.same_bed_with), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sleepingArrangementWith.value, (option) => {
            return (_openBlock(), _createBlock(CheckboxInput, {
              key: option.label,
              id: 'room' + option.id,
              name: option.value,
              label: option.label,
              checked: form.value.same_room_with.indexOf(option.id) > -1,
              onClick: ($event: any) => (removeAddRelatedTypes(form.value.same_room_with, option.id))
            }, null, 8, ["id", "name", "label", "checked", "onClick"]))
          }), 128))
        ]),
        (errors.value?.same_room_with)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errors.value?.same_room_with), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(livingArrangements.value, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.label,
                class: "sm:px-2 sm:py-2 py-1.5"
              }, [
                _createVNode(CheckboxInput, {
                  id: 'abuse' + option.id,
                  name: option.value,
                  label: option.label,
                  checked: form.value.abused_living_arrangement?.indexOf(option.id) > -1,
                  onClick: ($event: any) => (removeAddRelatedTypes(form.value.abused_living_arrangement, option.id))
                }, null, 8, ["id", "name", "label", "checked", "onClick"]),
                (errors.value?.abused_living_arrangement)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(errors.value?.abused_living_arrangement), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(livingArrangements.value, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.label,
                class: "sm:px-2 sm:py-2 py-1.5"
              }, [
                _createVNode(CheckboxInput, {
                  id: 'present' + option.id,
                  name: option.value,
                  label: option.label,
                  checked: form.value.present_living_arrangement?.indexOf(option.id) > -1,
                  onClick: ($event: any) => (removeAddRelatedTypes(form.value.present_living_arrangement, option.id))
                }, null, 8, ["id", "name", "label", "checked", "onClick"]),
                (errors.value?.present_living_arrangement)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(errors.value?.present_living_arrangement), 1))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(SuccessModal, {
        noBtn: "",
        show: showSuccess.value,
        "action-text": "Close",
        title: "Record Save",
        content: "Intake has been updated",
        onClose: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false))
      }, null, 8, ["show"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }, 8, ["patient"]))
}
}

})